export default "__VITE_ASSET__72ee0ec6__"